/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('site.anchorNav', function (el) {
        var updateActive = function (activeId) {
            el.querySelectorAll('a').forEach(function (a) {
                a.classList.remove('active');
            });
            var active = el.querySelector('a[href$="' + activeId + '"]');
            if (active) {
                active.classList.add('active');
            }
        };
        util.delegate(el, 'click', 'a', function (e) {
            updateActive(e.target.getAttribute('href').replace('#', ''));
        });
        var observerOptions = {
            root: null,
            rootMargin: "300px",
            threshold: .6
        };
        function observerCallback(entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    updateActive(entry.target.getAttribute('id'));
                }
            });
        }
        var observer = new IntersectionObserver(observerCallback, observerOptions);
        var boxes = document.querySelectorAll('main .box.hasAnchor');
        boxes.forEach(function (el) { return observer.observe(el); });
        var header = document.querySelector('header');
        var scrollPos = 0;
        window.addEventListener('scroll', function () {
            var bodyBoundingClientRect = document.body.getBoundingClientRect();
            if (bodyBoundingClientRect.top > scrollPos) {
                document.body.setAttribute('data-scroll-direction', 'up');
                if (header.offsetHeight + header.getBoundingClientRect().top <= 89) {
                    document.body.classList.add('hasStickyAnchor');
                }
                else {
                    document.body.classList.remove('hasStickyAnchor');
                }
            }
            else {
                document.body.setAttribute('data-scroll-direction', 'down');
                if (header.offsetHeight + header.getBoundingClientRect().top < 0) {
                    document.body.classList.add('hasStickyAnchor');
                }
                else {
                    document.body.classList.remove('hasStickyAnchor');
                }
            }
            if (document.body.clientWidth < 768) {
                if (bodyBoundingClientRect.top < -80) {
                    document.body.classList.add('hasStickyAnchor');
                }
                else {
                    document.body.classList.remove('hasStickyAnchor');
                }
            }
            scrollPos = bodyBoundingClientRect.top;
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
